import { render, staticRenderFns } from "./editFile.vue?vue&type=template&id=cce2c68e&scoped=true"
import script from "./editFile.vue?vue&type=script&lang=js"
export * from "./editFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce2c68e",
  null
  
)

export default component.exports